import type { AuditEntry } from "../types";

export function AuditPage({
  items,
  total,
  onRefresh
}: {
  items: AuditEntry[];
  total: number;
  onRefresh: () => Promise<void>;
}) {
  return (
    <>
      <div className="topbar">
        <div>
          <h1>Audit Log</h1>
          <p>
            Security Center · immutable trail of WHM and account actions.
          </p>
        </div>
        <div className="topbar-actions">
          <button type="button" className="btn btn-ghost" onClick={() => onRefresh()}>
            Refresh
          </button>
          <span className="phase-pill">{total} events</span>
        </div>
      </div>

      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>When</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Target</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {items.map((e) => (
              <tr key={e.id}>
                <td className="mono faint">
                  {new Date(e.createdAt).toLocaleString()}
                </td>
                <td className="mono">{e.actorUsername || "—"}</td>
                <td>
                  <span className="badge action">{e.action}</span>
                </td>
                <td className="mono faint">
                  {e.targetType ? `${e.targetType}:` : ""}
                  {e.targetId ? e.targetId.slice(0, 8) : "—"}
                </td>
                <td className="mono faint">{e.ip || "—"}</td>
              </tr>
            ))}
            {items.length === 0 ? (
              <tr>
                <td colSpan={5} className="empty">
                  No audit events yet.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </>
  );
}
